import { createAsyncThunk } from "@reduxjs/toolkit";
import { useGetData } from "../../../hooks/useGetData";
import { useUpdateData } from "../../../hooks/useUpdateData";
import { useInsertData } from "../../../hooks/useInsertData";
import { useDeleteData } from "../../../hooks/useDeleteData";
import notify from "../../../components/notify";


export const addProductFormData = createAsyncThunk(
  "/usersSlice/addNewUserFormData",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/products`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);

export const editProductFormData = createAsyncThunk(
  "/usersSlice/editProductFormData",
  async ({id,formData}, { rejectWithValue }) => {
    try {
      const response = await useUpdateData(`v1/products/${id}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const getProduct = createAsyncThunk(
  "/usersSlice/getProduct",
  async ({query=null}, { rejectWithValue }) => {
    try {
        let api = `v1/products`
        if(query) api+=`?${query}`
      const response = await useGetData(api);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const getoneProduct = createAsyncThunk(
  "/usersSlice/getoneProduct",
  async ({id=''}, { rejectWithValue }) => {
    try {
      const response = await useGetData(`v1/products/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);
export const deleteProduct = createAsyncThunk(
  "/usersSlice/deleteProduct",
  async ({id=''}, { rejectWithValue }) => {
    try {
      const response = await useDeleteData(`v1/products/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);


export const addComment = createAsyncThunk(
  "/usersSlice/addComment",
  async ({ data, rejectWithValue }) => {
    try {
      const response = await useInsertData(`v1/products/addComment`, data);
      console.log("response", response);
      notify(response.message, "success");
      return response?.comment;
    } catch (error) {
      if (error.message == "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({ message:"حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري " });
      } else {
        notify(error.response.data.message, "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);

export const getComments = createAsyncThunk(
  "/usersSlice/getComments",
  async ({id}, { rejectWithValue }) => {
    try {
       
      const response = await useGetData(`v1/products/getComment/${id}`);
      console.log("response", response);
      notify(response.message, "success");
      return response;
    } catch (error) {
      if (error.message === "Network Error") {
        notify("حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ", "error");
        return rejectWithValue({
          message: "حدث خطأ اثناء الاتصال بالانترنت حاول مرة اخري ",
        });
      } else {
        notify(error.response?.data?.message || "خطأ غير معروف", "error");
        return rejectWithValue(
          error.response?.data?.message || error?.response?.data
        );
      }
    }
  }
);


export const resetProduct = createAsyncThunk(
  "/usersSlice/resetProduct",
   () => {
    return true
  }
   
);




